'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Ad types

/**
 * Top ad in content
 * @type {string}
 */
var TOP_AD = exports.TOP_AD = 'Top Ad';

/**
 * Sticky ad in right rail
 * @type {string}
 */
var STICKY_RIGHT_RAIL_AD = exports.STICKY_RIGHT_RAIL_AD = 'Sticky Right Rail Ad';

/**
 * Ads embedded on the body content
 * @type {string}
 */
var IN_BODY_AD = exports.IN_BODY_AD = 'In Body Ad';

/**
 * Top ad in right rail
 * @type {string}
 */
var RIGHT_RAIL_TOP_AD = exports.RIGHT_RAIL_TOP_AD = 'Right Rail Top Ad';
/**
 * Top ad in right rail with video lead
 * @type {string}
 */
var RIGHT_RAIL_FW_TOP_AD_VIDEO = exports.RIGHT_RAIL_FW_TOP_AD_VIDEO = 'Right Rail Top Ad Video';

/**
 * Section - Desktop Skin Ad
 * @type {string}
 */
var SKIN_AD = exports.SKIN_AD = 'Skin Ad';

/**
 * Section - Desktop Interstitial
 * @type {string}
 */
var INTERSTITIAL_AD = exports.INTERSTITIAL_AD = 'Interstitial Ad';

/**
 * Section - Native ad
 * @type {string}
 */
var NATIVE_AD = exports.NATIVE_AD = 'Native Ad';

/**
 * Section - TripleLift Native ad
 * @type {string}
 */
var TRIPLELIFT_NATIVE_AD = exports.TRIPLELIFT_NATIVE_AD = 'TripleLift Native Ad';

/**
 * Middle body ad
 * @type {string}
 */
var MID_AD = exports.MID_AD = 'Middle Ad';

/**
 * Ad inside widget
 * @type {string}
 */
var WIDGET_AD = exports.WIDGET_AD = 'Widget Ad';

/**
 * Ad inside slideshows
 * @type {string}
 */
var IN_SLIDE_AD = exports.IN_SLIDE_AD = 'In Slide Ad';

/**
 * Ad on the right of horizontal slideshow
 * @type {string}
 */
var SLIDESHOW_RIGHT_AD = exports.SLIDESHOW_RIGHT_AD = 'Slidshow Right Ad';

/**
 * Ad on the top of slideshow to allow refresh
 * @type {string}
 */
var SLIDESHOW_TOP_AD = exports.SLIDESHOW_TOP_AD = 'Sideshow Top Ad';

/**
 * Inline Ad on vertical slidshow
 * @type {string}
 */
var SLIDESHOW_INLINE_AD = exports.SLIDESHOW_INLINE_AD = 'Sideshow Inline Ad';

/**
 * Video Companion
 * @type {string}
 */
var VIDEO_COMP_AD = exports.VIDEO_COMP_AD = 'Video Comp Ad';

/**
 * Freewheel SLED ad
 * @type {string}
 */
var SLED_AD = exports.SLED_AD = 'Sled Ad';


//////////////////
// WEBPACK FOOTER
// ./~/@univision/fe-commons/dist/utils/ads/ad-types.js
// module id = 66
// module chunks = 35783957827783